import { render, staticRenderFns } from "./AlertsStore.vue?vue&type=template&id=535c985d"
import script from "./AlertsStore.vue?vue&type=script&lang=js"
export * from "./AlertsStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports